import React, {useEffect, useState} from 'react';
import Layout from "../../components/Layout";
import axios from "axios";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Spinner from "../../components/Spinner/Spinner";

const NewsMain = () => {
    const [clubs, setClubs] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() =>{
        axios('https://www.thesportsdb.com/api/v1/json/1/search_all_teams.php?l=English%20Premier%20League')
            .then(({data}) => {
                setClubs(data.teams)
                setLoading(false)
            })
    },[])

    if (loading){
        return <Spinner/>
    }
    return (
       <Layout>
           <OwlCarousel className='owl-theme' margin={10} items={5} autoplay={true} dots={false}>
           {
               clubs.map(el =>
                   <img src={el.strTeamBadge} alt=""/>
               )
           }
           </OwlCarousel>
       </Layout>
    );
};

export default NewsMain;